import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import styles from './SubAreaOptions.styles';
import Select from '../../FormFields/Select';
import SubAreaDataEntry from '../SubAreaDataEntry';
const useStyles = makeStyles(styles);

const SubAreaOptions = ({ layer, options, onChange }) => {
  const classes = useStyles();
  const selectedOption = (options && options.length)
      ? options.find(opt => opt.sketchSubAreaOptionId === layer['sketchSubAreaOptionId'])
      : null
    ;
  return (<React.Fragment>
    <Select
      label={'SubArea Option Select'}
      optionValueKey={'sketchSubAreaOptionId'}
      optionLabelKey={'name'}
      options={options}
      value={layer['sketchSubAreaOptionId']}
      onChange={(val) => {
        onChange(layer.id, 'sketchSubAreaOptionId', val);
      }}
    />
    {
      (selectedOption && selectedOption.dataEntry && selectedOption.dataEntry.length)
      ? <SubAreaDataEntry layer={layer} options={selectedOption.dataEntry} onChange={onChange} />
      : null
    }
  </React.Fragment>);
};
SubAreaOptions.defaultProps = {};
SubAreaOptions.propTypes = {
};

export default SubAreaOptions;
